// extracted by mini-css-extract-plugin
export default {"Block":"Block_Block__4ebpx","Blended":"Block_Blended__LneOk","Compact":"Block_Compact__-f0mg"};